import { computed } from '@nuxtjs/composition-api'
import Vue from 'vue'

export function useModal (root: Vue) {
    const data = computed(() => {
        return root.$store.state.modalComponents.data
    })

    const closeModal = () => {
        root.$store.dispatch('modal/close')
    }

    const openModal = (name: string, modalData: Record<string, unknown> = {}) => {
        root.$store.dispatch('modalComponents/open', {
            name,
            ...modalData
        })
    }

    return {
        data,
        closeModal,
        openModal
    }
}
